import { QuoteReport } from "./Enums";

export class GridFilter {
  asc: boolean;
  companyId: string;
  dateFilters: [];
  report: QuoteReport;
  search: "";
  skip: 0;
  sort: "StartDate";
  statusFilters: [];
  stringFilters: [];
  take: 30;
}
